// import React from 'react'
import Dashboard from "../Dashboard/Dashboard";
import DashboardTraveler from "../Dashboard/DashboardTraveler";
import { useSelector } from "react-redux";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function CommonDashboard() {
    let navigate = useNavigate();

    const { user, isAuthenticated, token, travelerInfo,payment } = useSelector((state) => state.auth);
    const { faqsList, cityList } = useSelector((state) => state.homePageData);
 
    useEffect(() => {
        if (!isAuthenticated) {
            navigate("/");
        }
    }, [isAuthenticated, navigate]);

    return (
        <div>
            {user && Object.keys(user).length !== 0 && (user.payment_status === 'Pending' || user.payment_status === 'Cancel') &&
                <DashboardTraveler traveler={user} travelerInfoData={travelerInfo} cityList={cityList} token={token} />
            }
            {user && Object.keys(user).length !== 0 && (user.payment_status === 'COMPLETED' || user.payment_status === 'Success') &&
                <Dashboard sender={user} senderInfoData={travelerInfo} token={token} payment={payment} />
            }
        </div>
    )
}

export default CommonDashboard